import * as React from "react";
const SvgMobilePhone = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.684 1.871v20.256H19.314V1.871H12ZM6.19 3.38H17.81V20.62H6.19V12Zm3.936 13.498v1.498H13.871v-1.498H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgMobilePhone;
